import React, { useEffect, useState } from "react";
import Modalheader from "components/modal/components/header";
import useModal from "components/modal/useModal";

import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Firstform from "components/modal/dataModal/data/modaljustify/address/component/body/firstform";
import Multiform from "components/modal/dataModal/data/modaljustify/address/component/multiform";
import Button from "components/button";
import { CheckIcon } from "assets/icons";
import axios from "axios";
import { toast } from "react-toastify";
import usefetchdata from "hooks/usefetchdata";
import Footerbutton from "components/modal/dataModal/data/modaljustify/address/component/footer/footerbutton";
import UseContext from "hooks/useContext";
import LoadingButton from "components/button/loading.js";

const Proofaddress = () => {
    const { toggle } = useModal();
    const { tempWorkerData } = usefetchdata();
    const { language, refreshLoadWorker } = UseContext();
    const [check, setCheck] = useState(true);
    const [formIndex, setFormIndex] = useState(1);
    const [proof, setProof] = useState("");
    const [files, setFiles] = useState(false);
    const [attestation, setAttestation] = useState("");
    const [loading, setLoading] = useState(false);

    const pAddressMulti =
        tempWorkerData?.proof_of_address?.validated === "1" &&
        tempWorkerData?.accommodation_of_address?.validated === "1";

    const pAddressSingle = tempWorkerData?.proof_of_address?.validated === "1";
    useEffect(() => {
        if (pAddressMulti && formIndex < 4 && pAddressSingle && formIndex < 4) {
            setFormIndex(5);
            setFiles(true);
            setCheck(false);
        } else {
            setFiles(false);
        }
    }, [formIndex, tempWorkerData]);

    const singleFile = async (data) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            
            // Extraire le fichier du FormData reçu
            const file = data.get("file");
            formData.append("proofAddress", file);
            formData.append("token", token);

            await axios
                .post(
                    `${process.env.REACT_APP_API_URL}upload/files`,
                    formData
                )
                .then((res) => {
                    if (res.data && res.status === 201) {
                        // Vérifier si l'upload a réussi
                        const hasFailures = res.data.failures && res.data.failures.length > 0;
                        
                        if (hasFailures) {
                            toast.error("Un problème est survenu");
                        } else {
                        if (formIndex === 4) {
                            toast.success(
                                'Le document "Justificatif de domicile" est modifié.'
                            );
                            setFormIndex(3);
                            toggle();
                            refreshLoadWorker();
                        } else {
                            toast.success(
                                'Le document "Justificatif de domicile" est ajouté.'
                            );
                            toggle();
                            refreshLoadWorker();
                        }
                    }
                    } else {
                        toast.error("Un problème est survenu");
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    toast.error(e.response?.data?.error || "Un problème est survenu");
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    const secondFile = async (data) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            
            // Extraire le fichier du FormData reçu
            const file = data.get("file");
            formData.append("accommodationCertificate", file);
            formData.append("token", token);

            await axios
                .post(
                    `${process.env.REACT_APP_API_URL}upload/files`,
                    formData
                )
                .then((res) => {
                    if (res.data && res.status === 201) {
                        // Vérifier si l'upload a réussi
                        const hasFailures = res.data.failures && res.data.failures.length > 0;
                        
                        if (hasFailures) {
                            toast.error("Un problème est survenu");
                        } else {
                        toast.success(
                            'Le document "Attestation de domicile" est modifié.'
                        );
                        refreshLoadWorker();
                        setFormIndex(3);
                        toggle();
                    }
                    } else {
                        toast.error("Un problème est survenu");
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    toast.error(e.response?.data?.error || "Un problème est survenu");
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    const multiFiles = async (proofFile, attestationFile) => {
        setLoading(true);
        const idToastLoad = toast.loading("Envoi des fichiers en cours");
        
        try {
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            
            // Ajouter les fichiers avec les noms de champs attendus par le backend
            // Ne pas ajouter si le fichier est vide
            if (proofFile && proofFile !== "") {
                formData.append("proofAddress", proofFile);
            }
            if (attestationFile && attestationFile !== "") {
                formData.append("accommodationCertificate", attestationFile);
            }
            formData.append("token", token);

            const result = await axios.post(
                `${process.env.REACT_APP_API_URL}upload/files`,
                formData
            );

            if (result.status === 201 && result.data) {
                // Vérifier si tous les fichiers ont été uploadés avec succès
                const hasFailures = result.data.failures && result.data.failures.length > 0;
                
                if (hasFailures) {
                    toast.update(idToastLoad, {
                        render: "Certains fichiers n'ont pas pu être téléchargés",
                        type: "error",
                        autoClose: 3000,
                        isLoading: false,
                    });
                } else {
            toast.update(idToastLoad, {
                render: "Fichiers uploadés",
                type: "success",
                autoClose: 3000,
                isLoading: false,
            });
            setProof("");
            setAttestation("");
            refreshLoadWorker();
            toggle();
                }
        } else {
                toast.update(idToastLoad, {
                    render: "Erreur d'envoi des fichiers",
                    type: "error",
                    autoClose: 3000,
                    isLoading: false,
                });
            }
        } catch (error) {
            toast.update(idToastLoad, {
                render: error.response?.data?.error || "Erreur d'envoi des fichiers",
                type: "error",
                autoClose: 3000,
                isLoading: false,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCheck = (e) => {
        e.preventDefault();
        setCheck(!check);
    };

    const handleIndex = (e) => {
        e.preventDefault();

        if(((formIndex === 1 || formIndex === 2 || formIndex === 6) && proof) || ((formIndex === 3 || formIndex === 4 || formIndex === 8) && attestation)){
            setFormIndex(formIndex + 1);
        } else {
            toast.warning("Veuillez importer un fichier");
        }
    };

    const handleSubmitSingle = async (e) => {
        e.preventDefault();
        if (proof !== "") {
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            formData.append("file", proof);
            formData.append("token", token);
            await singleFile(formData);
        } else toast.warning("Veuillez télécharger un fichier");
    };

    const handleSubmitMultiSingle = async (e) => {
        if ((proof !== "" || attestation !== "") && !files) {
            e.preventDefault();
            // Passer directement les fichiers File à multiFiles
            await multiFiles(proof, attestation);
        } else {
            if(proof === '' && attestation === '') return toggle();
            toast.warning("Veuillez télécharger les fichiers");
        }
    };

    const handleSubmitProof = async (e) => {
        e.preventDefault();
        if (proof !== "") {
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            formData.append("file", proof);
            formData.append("token", token);
            await singleFile(formData);
        } else toast.warning("Veuillez télécharger un fichier");
    };

    const handleSubmitAttest = async (e) => {
        e.preventDefault();
        if (attestation !== "") {
            const token = localStorage.getItem("xsrfToken");
            const formDataSecond = new FormData();
            formDataSecond.append("file", attestation);
            formDataSecond.append("token", token);
            await secondFile(formDataSecond);
        } else toast.warning("Veuillez télécharger un fichier");
    };


    return (
        <>
            <Modalheader hideShow={true} hide={toggle}>
                {language.getValue("justify.m_proof_title_c")}
            </Modalheader>
            <ModalBody>
                <Multiform
                    formIndex={formIndex}
                    setFormIndex={setFormIndex}
                    setProof={setProof}
                    proof={proof}
                    setAttestation={setAttestation}
                    attestation={attestation}
                    setCheck={setCheck}
                    check={check}
                />
                {formIndex !== 1 ? (
                    ""
                ) : (
                    <div className={" ft-sm mt-4 flex items-center gap-2 cursor-pointer"}
                        onClick={handleCheck}
                    >
                        <div className={`flex items-center justify-center h-4 w-4 border border-gray-300 rounded-sm bg-white ${check ? "bg-yellow-600 border-yellow-600" : ""} focus:outline-none transition duration-200`}>
                            {check ? (
                                <CheckIcon w={14} h={10} color={"#ffff"} />
                            ) : (
                                ""
                            )}
                        </div>
                        Le justificatif d’adresse est à mon nom
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"} />
                ) : (
                    <>
                        {
                            (formIndex === 1 || formIndex === 6 || formIndex === 8) ? (
                                <Button
                                    size={"LG"}
                                    color={"SECONDARY"}
                                    onClick={toggle}
                                >
                                    Annuler
                                </Button>
                            ) : (
                                <Button
                                    size={"LG"}
                                    color={"SECONDARY"}
                                    onClick={() => setFormIndex(formIndex - 1)}
                                >
                                    Précédent
                                </Button>
                            )
                        }

                        <Footerbutton
                            formIndex={formIndex}
                            check={check}
                            oC1={handleIndex}
                            oC2={handleSubmitMultiSingle}
                            oC3={handleSubmitProof}
                            oC4={handleSubmitAttest}
                            oC5={handleSubmitSingle}
                        />
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default Proofaddress;
